import createMarker from '@PROJECT_ROOT/assets/shared/js/map/createMarker';

export default function makeCreateFacilityMarker(dependencies) {
    return createFacilityMarker.bind(null, dependencies);
}

export function createFacilityMarker(dependencies, facility, clickHandler) {
    const hasTotalPrice = Boolean(facility.totalPrice) && facility.totalPrice !== '0';

    const priceIconURL = facility.totalPrice.length < 6
        ? dependencies.facilityPriceSmallIcon
        : dependencies.facilityPriceMediumIcon;
    const activePriceIconURL = facility.totalPrice.length < 6
        ? dependencies.activeFacilityPriceSmallIcon
        : dependencies.activeFacilityPriceMediumIcon;

    const facilityIconData = {
        url: hasTotalPrice ? priceIconURL : dependencies.facilityIcon,
        labelOrigin: getIconLabelOrigin(facility.totalPrice.length),
    };
    const facilityActiveIconData = {
        url: hasTotalPrice ? activePriceIconURL : dependencies.activeFacilityIcon,
        labelOrigin: getIconLabelOrigin(facility.totalPrice.length),
    };

    const googleOptions = {
        map: dependencies.googleMap,
        position: {
            lat: parseFloat(facility.location.latitude),
            lng: parseFloat(facility.location.longitude),
        },
        icon: { url: dependencies.facilityIcon },
    };
    const customOptions = {
        iconData: facilityIconData,
        activeIconData: facilityActiveIconData,
        markerBounceType: hasTotalPrice ? 'flash' : 'bounce',
    };

    if (hasTotalPrice) {
        googleOptions.icon.url = priceIconURL;
        googleOptions.icon.labelOrigin = getIconLabelOrigin(facility.totalPrice.length);
        googleOptions.label = {
            text: String(facility.totalPrice),
            color: '#fff',
            fontFamily: 'Arial',
            fontSize: '17px',
            fontWeight: 'bold',
        };
    }

    const marker = createMarker(dependencies.google, googleOptions, customOptions, clickHandler);

    marker.facilityId = facility.id;
    marker.doubleFacilities = facility.doubleFacilities;

    return marker;
}

function getIconLabelOrigin(labelLength) {
    return labelLength < 6 ? { x: 25, y: 14 } : { x: 30, y: 14 };
}
